
import { defineComponent } from 'vue';
import ToggleTheme from '@/components/toggle-theme.vue';
import AuthSignIn from '@/components/auth-sign-in.vue';

export default defineComponent({
  name: 'App',
  components: { AuthSignIn, ToggleTheme },
});
